import baseURL from "../common/axios";

class ItemStoreMappingService {
  getroommaster(data) {
    return baseURL.httpMSInventoryUrl.get(
      "Custom/RoomMASListByStoreId?Id=" + data
    );
  }

  getrackmaster(data) {
    return baseURL.httpMSInventoryUrl.get("Custom/GetRackByStoreId?Id=" + data);
  }

  GetRowByStoreId(Id) {
    return baseURL.httpMSInventoryUrl.get("Custom/GetRowByStoreId?Id=" + Id);
  }

  GetBoxByStoreId(Id) {
    return baseURL.httpMSInventoryUrl.get("Custom/GetBoxByStoreId?Id=" + Id);
  }

  getrowmaster(data) {
    return baseURL.httpMSInventoryUrl.get("Custom/RowMASListByRoomId=" + data);
  }

  getboxmaster(data) {
    return baseURL.httpMSInventoryUrl.get("Custom/GetBoxByRowId?id=" + data);
  }
  getboxmasterGRN(data) {
    return baseURL.httpMSInventoryUrl.get("Custom/GetBoxByRowIdGRN?id=" + data);
  }

  // Item category mapping creation api for form
  Iscreate(data_insert) {
    return baseURL.httpMSInventoryUrl.post(
      "ItemStoreMappingMAP/Create",
      data_insert
    );
  }
  // getSetReOrderLevelItemByStoreId(StoreId, BranchId, HospitalId) {
  //   return baseURL.httpMSInventoryUrl.get(
  //     "ItemStoreMappingMAP/GetSetReOrderLevelItemByStoreId?StoreId=" + StoreId + "&HospitalId=" + HospitalId + "&BranchId=" + BranchId
  //   );
  // }
  Ismulticreate(data_insert) {
    return baseURL.httpMSInventoryUrl.post(
      "ItemStoreMappingMAP/CreateStoreCategoryItemMap",
      data_insert
    );
  }

  // Item category mapping creation api for form
  Isupdate(data_insert) {
    return baseURL.httpMSInventoryUrl.post(
      "ItemStoreMappingMAP/Update",
      data_insert
    );
  }
  // delete data from table
  deletedata(data_insert) {
    return baseURL.httpMSInventoryUrl.delete(
      "ItemStoreMappingMAP/Delete?id=" + data_insert
    );
  }

  // List all table data from api
  List(Id, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/StoreCategoryMappingListByStoreId?id=" +
      Id +
      "&BranchId=" +
      BranchId
    );
  }

  // category list mapping for store
  storecatlist() {
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/StoreCategoryMappingList"
    );
  }

  multistorecatlist(HospitalId, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/StoreCategoryMappingListNew?HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId
    );
  }
  ItemList() {
    return baseURL.httpMSInventoryUrl.get("ItemStoreMappingMAP/List");
  }
  getbystoreID(id) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/GetByStoreId?StoreId=" + id
    );
  }

  // delete data with category and store id
  delete(storeid, catid) {
    return baseURL.httpMSInventoryUrl.delete(
      "ItemStoreMappingMAP/ItemDeleteByStoreIdCategoryId?StoreId=" +
      storeid +
      "&categoryId=" +
      catid
    );
  }

  // store category mapping service apis

  create(data_insert) {
    return baseURL.httpMSInventoryUrl.post(
      "StoreCategoryMapping/Create",
      data_insert
    );
  }

  update(data_insert) {
    return baseURL.httpMSInventoryUrl.post(
      "StoreCategoryMapping/Update",
      data_insert
    );
  }
  get(data_insert) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreCategoryMapping/Get?Id=" + data_insert
    );
  }
  StoreCategoryMappingget(data_insert, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreCategoryMapping/GetCategoryByStoreId?StoreId=" +
      data_insert +
      "&BranchId=" +
      BranchId
    );
  }
  liststorecatgorymapping(UserId, OrganizationId, IsAdmin, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "StoreCategoryMapping/ListCustom?UserId=" +
      UserId +
      "&OrganizationId=" +
      OrganizationId +
      "&IsAdmin=" +
      IsAdmin +
      "&BranchId=" +
      BranchId
    );
  }
  deletestorecatmap(id) {
    return baseURL.httpMSInventoryUrl.delete(
      "StoreCategoryMapping/Delete?Id=" + id
    );
  }

  GetItemStoreMappingDetail(HospitalId, BranchId, StoreId) {
    return baseURL.httpMSInventoryUrl.get("ItemStoreMappingMAP/GetItemStoreMappingDetail?HospitalId=" +
      HospitalId + "&BranchId=" + BranchId + "&StoreId=" + StoreId + "");
  }
}
export default new ItemStoreMappingService();
